import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const WidgetCardWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      p="12px"
      borderRadius="20px"
      bg="var(--bgCompSecondaryTiny)"
      border="1px solid rgba(255, 255, 255, 0.08)"
      backdropFilter="blur(16px)"
      display="flex"
      flexDirection="column"
      gap="8px"
    >
      {children}
    </Box>
  );
};
